import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const Section = styled.section`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColor }) => backgroundColor};
  position: relative;
  z-index: 1;

  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row;
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
  }

  @media (min-width: 1280px) and (min-height: 1300px) {
    height: 1235px;
  }

  @media (min-width: 1920px) and (max-height: 899px) {
    min-height: 600px;
  }
  @media (min-width: 1280px) and (max-height: 699px) {
    min-height: 500px;
  }
`;

export const TextContainer = styled(UI.HalfContainerNarrow)``;



// WEBPACK FOOTER //
// ./src/components/modules/Contacts/styled.js